import { render, staticRenderFns } from "./StandardArrowNavigation.vue?vue&type=template&id=5bb88266"
import script from "./StandardArrowNavigation.vue?vue&type=script&lang=js"
export * from "./StandardArrowNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports